var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "deposit-detail-footer" }, [
      _c(
        "div",
        {
          staticClass: "footer",
          class: { ml0: !_vm.showMenu, ml220: _vm.showMenu }
        },
        [
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "row group-status" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-xs btn-status",
                    style: {
                      "background-color": _vm.deposit.statusDetail
                        ? _vm.deposit.statusDetail.color
                        : "#fff",
                      cursor: "context-menu"
                    },
                    attrs: { href: "javascript: void(0)" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        (_vm.deposit.depositCode
                          ? _vm.deposit.depositCode
                          : "KG" + _vm.deposit.id) +
                          " - " +
                          (_vm.deposit.statusDetail
                            ? _vm.deposit.statusDetail.title ||
                              _vm.deposit.statusDetail.name
                            : "")
                      )
                    )
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }